module.exports = __webpack_public_path__ + "img/Our_Inn_Place@3x.cf75c0ae.png";